<main>
  <div class="page-wrapper">
    <img src="assets/images/uc-logo.png" alt="UC Plus Advance" class="main-logo" />
    <section>
      <ng-content></ng-content>
    </section>
    <footer>
      <span class="copyright">© Mida Technologies {{ currentYear }}</span>
      <div class="powered-by">
        <span>Powered by</span>
        <img src="assets/images/midaCollect.png" alt="MidaCollect" />
      </div>
      <div class="links">
        <a href="">
          Privacy policy
          <img src="assets/icons/arr.svg" alt="arrow icon" />
        </a>
        <a href="https://getmida.com/" target="_blank">
          www.getmida.com
          <img src="assets/icons/arr.svg" alt="arrow icon" />
        </a>
      </div>
    </footer>
  </div>
</main>
